'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var ObjectHelper = require('../../common/ObjectHelper.js');

var FieldValidator =
/*#__PURE__*/
function () {
  function FieldValidator(fieldsThatMustBePresent, fieldsThatMustBeNumeric) {
    classCallCheck(this, FieldValidator);

    this.fieldsThatMustBePresent = fieldsThatMustBePresent;
    this.fieldsThatMustBeNumeric = fieldsThatMustBeNumeric;
    this.state = {};
  }

  createClass(FieldValidator, [{
    key: "validateForm",
    value: function validateForm(componentState) {
      var _this = this;

      var valid = true;
      this.fieldsThatMustBePresent.forEach(function (fieldName) {
        if (_this.fieldPresentValidation(componentState, fieldName) == false) {
          valid = false;
        }
      });
      this.fieldsThatMustBeNumeric.forEach(function (fieldName) {
        if (_this.fieldNumericValidation(componentState, fieldName) == false) {
          valid = false;
        }
      });
      return valid;
    }
  }, {
    key: "formIsValid",
    value: function formIsValid() {
      var _this2 = this;

      var valid = true;
      this.fieldsThatMustBePresent.forEach(function (fieldName) {
        if (_this2.hasFieldError(fieldName)) {
          valid = false;
        }
      });
      return valid;
    }
  }, {
    key: "hasFieldError",
    value: function hasFieldError(fieldName) {
      return ObjectHelper.isPresent(this.state[fieldName + 'Error']);
    }
  }, {
    key: "fieldError",
    value: function fieldError(fieldName) {
      return this.state[fieldName + 'Error'];
    }
  }, {
    key: "addFieldError",
    value: function addFieldError(fieldName, error) {
      return this.state[fieldName + 'Error'] = error;
    }
  }, {
    key: "fieldNumericValidation",
    value: function fieldNumericValidation(componentState, fieldName) {
      if (ObjectHelper.isPresent(componentState[fieldName]) && isNaN(componentState[fieldName]) == true) {
        this.state[fieldName + 'Error'] = 'must be a number';
        return false;
      } else {
        this.state[fieldName + 'Error'] = undefined;
        return false;
      }
    }
  }, {
    key: "fieldPresentValidation",
    value: function fieldPresentValidation(componentState, fieldName) {
      if (ObjectHelper.isPresent(componentState[fieldName])) {
        this.state[fieldName + 'Error'] = undefined;
        return true;
      } else {
        this.state[fieldName + 'Error'] = 'field required';
        return false;
      }
    }
  }]);

  return FieldValidator;
}();

module.exports = FieldValidator;
